import React from "react";
import { shimanoData } from "../../../data";


function Shimano() {
    const {
        brand,
        slogan,
        description,
        innovation,
        performance,
        safety,
        versatility,
        sustainability,
    } = shimanoData;

    return (
        <div className="w-full mx-auto space-y-5">
            {/* Brand Intro */}
            <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
                <h1 className="text-3xl font-bold text-gray-900 mb-2">{brand}</h1>
                {slogan && (
                    <p className="text-sm italic text-gray-500 mb-3">“{slogan}”</p>
                )}
                <p className="text-gray-700 leading-relaxed text-base">
                    {description}
                </p>
            </div>

            {/* Innovation */}
            <div className="max-sm:px-4">
                <h2 className="text-lg font-semibold text-gray-900 mb-1">
                    Innovative Technology
                </h2>
                <p className="text-gray-700 text-sm leading-relaxed">
                    {innovation.description}
                </p>
            </div>

            {/* Performance */}
            <div className="max-sm:px-4">
                <h2 className="text-lg font-semibold text-gray-900 mb-1">
                    High Performance Engineering
                </h2>
                <p className="text-gray-700 text-sm leading-relaxed">
                    {performance.description}
                </p>
            </div>

            {/* Safety */}
            <div className="max-sm:px-4">
                <h2 className="text-lg font-semibold text-gray-900 mb-1">
                    Advanced Braking & Control
                </h2>
                <p className="text-gray-700 text-sm leading-relaxed">
                    {safety.description}
                </p>
            </div>

            {/* Versatility */}
            <div className="max-sm:px-4">
                <h2 className="text-lg font-semibold text-gray-900 mb-1">
                    Versatility Across Disciplines
                </h2>
                <p className="text-gray-700 text-sm leading-relaxed">
                    {versatility.description}
                </p>
            </div>

            {/* Sustainability */}
            <div className="max-sm:px-4">
                <h2 className="text-lg font-semibold text-gray-900 mb-1">
                    Commitment to Sustainability
                </h2>
                <p className="text-gray-700 text-sm leading-relaxed">
                    {sustainability.description}
                </p>
            </div>
        </div>
    );
}

export default Shimano;
